<template>
  <div class="list-box">
    <ul class="list-search" style="justify-content: flex-end">
      <el-button
        type="primary"
        :icon="Plus"
        size="large"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        >添加</el-button
      >
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        row-key="id"
        default-expand-all
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          prop="name"
          sortable="name"
          label="名称"
          min-width="180"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column prop="code" sortable="code" label="路径">
          <template #default="{ row }">
            <text v-if="row.type == 1" style="color: #080">菜单</text>
            <text v-else style="color: #1390ff">按钮</text>
          </template>
        </el-table-column>
        <el-table-column prop="code" sortable="code" label="路径" />
        <el-table-column prop="icon" sortable="icon" label="图标" />
        <el-table-column prop="sort" sortable="sort" label="序号" width="90" />
        <el-table-column
          label="状态"
          prop="status"
          sortable="status"
          width="100"
          fixed="right"
        >
          <template #default="{ row }">
            <el-switch
              v-model="row.is_show"
              inline-prompt
              active-text="显示"
              active-color="#1e90ff"
              inactive-text="隐藏"
              inactive-color="#f00"
              :active-value="0"
              :inactive-value="1"
              style="--el-switch-off-color: #f00"
              @change="onChangeQt(row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '菜单'"
      @close="state.showInfo = false"
    >
      <c_MenuInfo
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_MenuInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { confirm_func } from "@/utils/qFormat";
import { menu_tree, menu_qt, menu_delete } from "@/http/menu";
import { ElMessageBox, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 0,
    sort_field: "sort",
    sort_value: "asc",
  };
}

export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    //加载菜单树
    const onLoad = () => {
      delete state.tableData;
      menu_tree().then((res) => {
        if (res.status == 200) {
          state.tableData = res.data.data.list;
        }
      });
    };

    //启停
    const onChangeQt = (row) => {
      ElMessageBox.confirm(
        `您确定${
          row.is_show == 1
            ? '<strong style="color:#f00">隐藏'
            : '<strong style="color:#1e90ff">显示'
        }</strong>该菜单吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          menu_qt(row).then((res) => {
            if (res.status == 200)
              ElMessage({
                type: "success",
                grouping: true,
                message: res.data.msg,
              });
          });
        })
        .catch(() => {
          row.is_show = row.is_show == 1 ? 0 : 1;
        });
    };

    //删除
    const onDelete = (id) => {
      confirm_func(menu_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onDelete,
      onChangeQt,
    };
  },
};
</script>
<style scoped lang="less"></style>
